import React from 'react'
import './JoinClub.css'
import img1 from '../../images/img10.png'
import img2 from '../../images/img11.png'
import img3 from '../../images/img12.png'
import img4 from '../../images/img13.png'

const Joinclub = () => {
    return (
        <div className='join-club'>
            <div className='join-club-content'>
                <div className='imgwork-images'>
                    <div className='top-imgwork-images'>
                        <img src={img1} alt='imgwork 1' />
                        <img
                            src={img2}
                            alt='imgwork 2'
                            className='last-imgwork'
                        />
                    </div>
                    <div className='bottom-imgwork-images'>
                        <img
                            src={img3}
                            alt='imgwork 3'
                            className='sub-imgwork'
                        />
                        <img
                            src={img4}
                            alt='imgwork 4'
                            className='last-imgwork'
                        />
                    </div>
                </div>
                <div className='join-club-text'>
                    <h1>
                         <span> Join the club</span>
                    </h1>
                    <p>
                        When you mint a Legend of Shangu, you are buying more
                        than just NFT art!
                        <br /> You are gaining access to an exclusive membership
                        into our community to interact and learn from successful
                        entrepreneurs, crypto and NFT whales, all while earning
                        passive income from the Royalties from owning our NFT’s.
                        Your Legends will serve as your digital identity, a VIP
                        pass for our Metaclub and access to exclusive real world
                        events and David Huynh art drops.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Joinclub
